<template>
  <div class="container mx-auto mt-28 px-2">
    <div class="text-center">
      <h1>Clip</h1>
      <h2><small>Carry this clipboard wherever you go</small></h2>
      <textarea class="my-4" ref="contentArea" v-model="state.clip.content"></textarea>
    </div>
    <div class="flex justify-between px-4 my-4">
      <button class="outline-primary" @click="overwrite">Paste</button>
      <button @click="copy">Copy</button>
    </div>


    <div class="max-w-xs my-4" 
      v-if="!state.clip.file_attachment && props.user?.id">
      <label for="file_attachment">Attach a file</label>
      <input id="file_attachment" type="file" @change="onFileChange"/>
    </div>
    <div v-if="!state.clip.file_attachment && !props.user?.id">
      <p class="text-sm text-gray-500">Only signed-in users can upload files</p>
    </div>
    <div v-if="state.clip.file_attachment">
      <label>Attached file:</label>
      <a class="px-2" :href="state.clip.file_attachment.redirect_path">
        {{state.clip.file_attachment.filename}}
      </a>
      <button class="outline-delete" @click="removeFile">Remove</button>
    </div>


    <div>
      <label for="read_only_link">Read-only link:</label>
      <div class="relative z-0 flex ">
      <input readonly type="url" id="read_only_link" class="rounded-r-none" v-model="readOnlyUrl" />
      <button
        class="outline-primary flex items-center space-x-1 px-2 rounded-l-none"
        @click="copyReadOnlyLink">
        <!--TODO: replace this with icon-->
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z" />
        </svg>
        <span>Copy</span>
      </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {reactive, ref, onMounted, computed} from 'vue'
import http from '../../helpers/http.js'

let props = defineProps({
  clip: Object,
  user: Object
})

let state = reactive({clip: props.clip})
let contentArea = ref(null)

let readOnlyUrl = computed(() => {
  return window.location.origin + '/clips/read_only/' + state.clip.read_only_token
})

onMounted(() => {
  contentArea.value.addEventListener('blur', onBlur)
})

let onBlur = () => {
  save()
}

let overwrite = () => {
  navigator.clipboard.readText().then((text) => {
    state.clip.content = text
  })
}

let copy = () => {
  navigator.clipboard.writeText(state.clip.content)
}

let copyReadOnlyLink = () => {
  navigator.clipboard.writeText(readOnlyUrl.value)
}

let save = () => {
  http.put(`/clips/${state.clip.token}`, {content: state.clip.content}).then(({data}) => {
    state.clip = data
  })
}

let onFileChange = (event) => {
  let file = event.target.files[0]
  let formData = new FormData()
  formData.append('file', file)

  http.put(`/clips/${state.clip.token}`, formData).then(({data}) => {
    state.clip = data
  })
}

let removeFile = () => {
  http.put(`/clips/${state.clip.token}`, {file: null}).then(({data}) => {
    state.clip = data
  })
}

</script>

<style scoped>
/*TODO: fix the need for this override*/
.rounded-r-none {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

#what {
  background-color: green;
}
#what::-moz-focus-inner {
  border: 1px solid red;
}
</style>